import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export default {
  state: {
    advertisers: [],
    advertiser: null,
    advertiser_id: parseInt(localStorage.getItem('l')),
    endpoints: {
      merchantCardCounts: 'https://stormy-mountain-29119.herokuapp.com/v3/merchant_card_counts/',
      merchantDetail: 'https://stormy-mountain-29119.herokuapp.com/v3/obtain_merchant/',
      updateMerchant: 'https://stormy-mountain-29119.herokuapp.com/v3/update_merchant/',
      merchantHideRewardGuideLink: 'https://stormy-mountain-29119.herokuapp.com/v3/merchant_hide_reward_guide_link/',
    },
  },
  mutations,
  actions,
  getters,
}